export const ENTITY_STATUS_POLL_INTERVAL_MS = 1_000;
export const ENTITY_STATUS_MAX_POLL_ATTEMPTS = 2;
export const ENTITY_NOT_FOUND_ERROR = 'entity.not-found';
